import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, GiftIcon } from 'lucide-react';
interface Bonus {
  number: number;
  title: string;
  image: string;
  items: string[];
}
export function Bonuses() {
  const [openBonus, setOpenBonus] = useState<number | null>(null);
  const bonuses: Bonus[] = [{
    number: 1,
    title: 'Checklist Profesional de Entrega',
    image: 'https://cdn.magicpatterns.com/uploads/q9iMfe7KVQ9tvznHNWAxEc/Screenshot_2026-06-05_at_11.51.00_PM.png',
    items: ['Listas de control para:', '🦷 Prótesis completas', '🦷 Prótesis parciales', '👑 Coronas', '🌉 Puentes']
  }, {
    number: 2,
    title: 'Plantilla Profesional de Orden de Trabajo',
    image: 'https://cdn.magicpatterns.com/uploads/gVHqa89zg45vBtfHwJ3BYH/Screenshot_2026-06-05_at_11.51.16_PM.png',
    items: ['✔️ Editable', '✔️ Lista para imprimir', '✔️ Datos clínicos y materiales', '✔️ Control de entregas']
  }, {
    number: 3,
    title: 'Tabla Visual de Materiales Dentales',
    image: 'https://cdn.magicpatterns.com/uploads/nTWophQ3kRDcT4GyaLn3cP/Screenshot_2026-06-05_at_11.52.15_PM.png',
    items: ['✔️ Material', '✔️ Uso', '✔️ Tiempo de trabajo', '✔️ Error frecuente', '✔️ Consejo rápido', 'Ideal para colgar en el laboratorio.']
  }, {
    number: 4,
    title: 'Calculadora de Precios para Técnicos Dentales',
    image: 'https://cdn.magicpatterns.com/uploads/2K7keWYhafCjMEgtpQhjoT/Screenshot_2026-06-05_at_11.52.34_PM.png',
    items: ['✔️ Costos automáticos', '✔️ Tiempo de trabajo', '✔️ Margen de ganancia', '✔️ Precio sugerido de venta', '✔️ Comparación con mercado']
  }, {
    number: 5,
    title: 'Hoja de Ruta: Del Acrílico al CAD/CAM en 12 Meses',
    image: 'https://cdn.magicpatterns.com/uploads/rXjChvHCUPHxwAy9GK6ANT/Screenshot_2026-06-05_at_11.53.02_PM.png',
    items: ['📍 Fundamentos', '📍 Prótesis removible', '📍 Prótesis fija', '📍 Flujo digital', '📍 CAD/CAM', '📍 Zirconia', '📍 Independización profesional']
  }];
  const toggleBonus = (index: number) => {
    setOpenBonus(openBonus === index ? null : index);
  };
  return <section className="w-full px-4 py-12 bg-white" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <div className="text-center mb-8" data-id="element-15">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-16">
            🎁 BONOS EXCLUSIVOS
          </h2>
          <p className="text-lg text-green-600 font-semibold" data-id="element-17">
            Gratis por el día de hoy
          </p>
        </div>

        <div className="space-y-4" data-id="element-18">
          {bonuses.map((bonus, index) => <div key={index} className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl shadow-md overflow-hidden border-2 border-yellow-200" data-id="element-19">
              {/* Preview image with gradient fade */}
              <div className="relative h-32 md:h-40 overflow-hidden" data-id="element-20">
                <img src={bonus.image} alt={`Vista previa: ${bonus.title}`} className="w-full h-full object-cover object-top" data-id="element-21" />
                <div className="absolute inset-0 bg-gradient-to-t from-yellow-50 via-yellow-50/40 to-transparent" data-id="element-22" />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-orange-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow" data-id="element-23">
                  <GiftIcon className="w-3.5 h-3.5" data-id="element-24" />
                  Bono {bonus.number}
                </span>
              </div>

              <button onClick={() => toggleBonus(index)} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-yellow-100 transition-colors" data-id="element-25">
                <h3 className="text-lg font-semibold text-gray-900 pr-4" data-id="element-26">
                  {bonus.title}
                </h3>
                {openBonus === index ? <ChevronUpIcon className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-27" /> : <ChevronDownIcon className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-28" />}
              </button>

              {openBonus === index && <div className="px-5 pb-5 pt-1 bg-yellow-50" data-id="element-29">
                  <ul className="space-y-2" data-id="element-30">
                    {bonus.items.map((item, itemIndex) => <li key={itemIndex} className="text-gray-700" data-id="element-31">
                        {item}
                      </li>)}
                  </ul>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}